define('components/photoset/layouts/factory', [
    'components/photoset/layouts/fitColumn/layout',
    'components/photoset/layouts/fitRow/layout'
], function (FitColumnLayout, FitRowLayout) {
    function Factory(config) {
        this._config = config;
    }

    Factory.prototype.build = function (name) {
        switch (name.toLowerCase()) {
            case 'fitrow': return new FitRowLayout(this._config);
            default: return new FitColumnLayout(this._config);
        }
    };

    return Factory;
});